import { render } from "./ConsultasDevolucoes.vue?vue&type=template&id=1cc0fa79&scoped=true"
import script from "./ConsultasDevolucoes.vue?vue&type=script&lang=js"
export * from "./ConsultasDevolucoes.vue?vue&type=script&lang=js"

import "./ConsultasDevolucoes.vue?vue&type=style&index=0&id=1cc0fa79&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cc0fa79"]])

export default __exports__